var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{directives:[{name:"hide-element",rawName:"v-hide-element",value:(false),expression:"false"}],staticClass:"ml-3 pa-0",attrs:{"text":"","height":"38","color":"gary","title":_vm.$t('GENERAL.REFRESH')},on:{"click":_vm.refresh}},[_c('v-icon',[_vm._v("mdi-refresh")]),_c('span',[_vm._v(_vm._s(_vm.$t('GENERAL.REFRESH')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }